export default __webpack_public_path__ + "static/media/ufo.51b20924.svg";